export default __webpack_public_path__ + "static/media/h-wrong_s.c0667957.jpg";